export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "es",
    "resource": {
      "signUpError": {
        "alertText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El registro ya se ha completado. Haga clic aquí para volver al capítulo correcto."])}
      }
    }
  })
}
